/**
 * Why the Lưu button is not yet enabled, in the person's words (decision AJ2, 2026-09-21).
 *
 * The button used to be silently disabled: a person who typed an amount and picked a category
 * but had no default account saw nothing happen and no reason. Every Quick Add form now derives
 * the same condition twice — once as `canSave`, once as a list of what is still missing — and
 * shows the list under the button. Pure and shared so the four forms cannot drift apart.
 */
export function missingFieldsMessage(missing: readonly (string | false | null)[]): string | null {
  const labels = missing.filter((item): item is string => typeof item === 'string' && item !== '');
  return labels.length === 0 ? null : `Còn thiếu: ${labels.join(', ')}`;
}

/**
 * The stored default account only counts while it is still one of the accounts on offer — an
 * archived default would otherwise pre-select nothing and hide the reason behind it.
 */
export function usableDefaultAccountId(
  defaultAccountId: string | null,
  accounts: readonly { id: string }[],
): string | null {
  return defaultAccountId !== null && accounts.some((account) => account.id === defaultAccountId)
    ? defaultAccountId
    : null;
}
